import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";

enum UserMapTransportPreferencesModalGTMEvent {
    railroadModal = "railroad_modal"
}

type IUserMapTransportPreferencesModalGTMAction = "view" | "close" | "railroad_map" | "normal_map";

export const hitGtmUserMapTransportPreferencesModalEvent = (action: IUserMapTransportPreferencesModalGTMAction) => {
    hitGoogleTagManager({
        event: UserMapTransportPreferencesModalGTMEvent.railroadModal,
        railroad_modal_action: action
    });
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";

enum UserMapTransportPreferencesModalGTMEvent {
    railroadModal = "railroad_modal"
}

type IUserMapTransportPreferencesModalGTMAction = "view" | "close" | "railroad_map" | "normal_map";

export const hitGtmUserMapTransportPreferencesModalEvent = (action: IUserMapTransportPreferencesModalGTMAction) => {
    hitGoogleTagManager({
        event: UserMapTransportPreferencesModalGTMEvent.railroadModal,
        railroad_modal_action: action
    });
};
